import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { FaFacebook, FaLinkedin, FaInstagram, FaGoogle } from 'react-icons/fa';
import siteData from '../data/siteData';

export default function Footer() {
  const { copyright_text, powered_by_text, contact_email, contact_phone } = siteData.footer;

  return (
    <footer className="footer-section">
      <div className="footer-top-wave" />

      <div className="container footer-grid">
        {/* Col 1 – Brand */}
        <div className="footer-col">
          <div className="footer-brand">
            <img src="/images/logo/logo-m.png" alt="ASRM Logo" className="footer-logo-img" />
            <div>
              <span className="footer-brand-name">ASRM & Co.</span>
              <span className="footer-brand-sub">Chartered Accountants</span>
            </div>
          </div>
          <p className="footer-brand-desc">
            Professionally managed CA Firm with 30+ years of combined experience, delivering premier financial, audit, tax and advisory services across India.
          </p>
        </div>

        {/* Col 2 – Useful Links */}
        <div className="footer-col">
          <h4 className="footer-col-title">Quick Links</h4>
          <ul className="footer-link-list">
            <li><Link to="/" className="footer-link"><FiArrowRight size={12} /> Home</Link></li>
            <li><Link to="/team" className="footer-link"><FiArrowRight size={12} /> Our Team</Link></li>
            <li><Link to="/services" className="footer-link"><FiArrowRight size={12} /> Services</Link></li>
            <li><Link to="/contact" className="footer-link"><FiArrowRight size={12} /> Contact Us</Link></li>

          </ul>
        </div>

        {/* Col 3 – Social Media & Main Contact */}
        <div className="footer-col">
          <h4 className="footer-col-title">Follow & Review Us</h4>
          <ul className="footer-link-list" style={{ marginBottom: 20 }}>
            <li>
              <a href="https://www.facebook.com/ASRM-CO-486599011395267/" target="_blank" rel="noopener noreferrer" className="footer-link">
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, backgroundColor: '#fff', borderRadius: 6 }}>
                  <FaFacebook size={18} style={{ color: '#1877F2' }} />
                </span>
                Facebook
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/asrmco.asansol?igsh=bDk2M2g1dzZjdmg0" target="_blank" rel="noopener noreferrer" className="footer-link">
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, backgroundColor: '#fff', borderRadius: 6 }}>
                  <FaInstagram size={18} style={{ color: '#E4405F' }} />
                </span>
                Instagram
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/asrm-co/" target="_blank" rel="noopener noreferrer" className="footer-link">
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, backgroundColor: '#fff', borderRadius: 6 }}>
                  <FaLinkedin size={18} style={{ color: '#0A66C2' }} />
                </span>
                LinkedIn
              </a>
            </li>
            <li>
              <a href="https://share.google/F36hkpodEs5my0qHY" target="_blank" rel="noopener noreferrer" className="footer-link">
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 28, height: 28, backgroundColor: '#fff', borderRadius: 6 }}>
                  <FaGoogle size={18} style={{ color: '#DB4437' }} />
                </span>
                Google Review
              </a>
            </li>
          </ul>
          <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div className="footer-contact-item" style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: '1rem', color: 'rgba(255, 255, 255, 0.8)' }}>
              <strong style={{ color: 'var(--white)' }}>Email:</strong>
              <a href={`mailto:${contact_email}`} style={{ textDecoration: 'none', color: 'inherit' }}>{contact_email}</a>
            </div>
            <div className="footer-contact-item" style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: '1rem', color: 'rgba(255, 255, 255, 0.8)' }}>
              <strong style={{ color: 'var(--white)' }}>Phone:</strong>
              <a href={`tel:${contact_phone.replace(/\s|-/g, '')}`} style={{ textDecoration: 'none', color: 'inherit' }}>{contact_phone}</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom-bar">
        <div className="container footer-bottom-inner">
          <p className="footer-copyright">{copyright_text}</p>
          <p className="footer-powered">Powered by <span style={{ color: 'var(--accent-light)' }}>{powered_by_text}</span></p>
        </div>
      </div>
    </footer>
  );
}
